import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { issuedCoverablesAndPricesAtom } from '../atoms/issuedCoverablesAndPricesAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { onsaProductStatusListAtom } from '../atoms/onsaProductStatusListAtom';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { coverableTaxMap } from '../../utils/coverablesUtil';

export const pricesAndTaxesSelector = selector({
    key: 'pricesAndTaxesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(issuedCoverablesAndPricesAtom);
        const onsaCoverables = get(onsaProductStatusListAtom);
        const coverables = get(allCoverablesAtom);
        const covs = { ...coverables, ...onsaCoverables };
        const pricesAndTaxes = await OnlineSalesUnauthenticated.getPricesAndTaxes(
            jobNumber,
            sessionId,
            !isLoggedOn
        );

        const filteredCoverables = Object.fromEntries(
            Object.entries(covs).filter(([key, value]) =>
                (value as CoverableDTO[]).find(
                    (cov) => cov.status === 'Added' || cov.status === undefined
                )
            )
        );

        const feesToShow = Object.fromEntries(
            Object.entries(coverableTaxMap).filter(([coverable, fee]) => {
                return Object.keys(filteredCoverables).find((cov) => cov === coverable);
            })
        );

        const filteredTaxes = pricesAndTaxes.annualTaxes?.filter((tax) => {
            return Object.entries(feesToShow).find(([cov, fees]) =>
                fees.find((fee) => fee === tax.feeName)
            );
        });

        return { ...pricesAndTaxes, annualTaxes: filteredTaxes };
    }
});
